import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { urtoast } from "../Layouts/CustomPopup/eventEmitter";
import { v4 as uuidv4 } from "uuid";
import DisplayFileProper from "./FilesRelevent/DisplayFileProper";
import DownloadButton from "./FilesRelevent/DownloadButton";
import AsteriskLabel from "./AsteriskLabel";
import { isAllowedFile } from "../../assests/extention/fileextention";

const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
const validDocumentTypes = ["application/pdf"];
const MAX_FILE_LIMIT = 5;

export default function CoverImages({
  formik,
  doctype,
  name = "files",
  title = "",
  type = "multiple", // "single" or "multiple"
}) {
  const [selectedFiles, setSelectedFiles] = useState(
    type == "single" ? null : []
  );

  // Sync formik values with local state
  useEffect(() => {
    const value = formik?.values[name];
    setSelectedFiles(type == "single" ? value || null : value || []);
  }, [formik?.values[name], type]);

  // 🔼 Handle file uploads
  const handleUpload = (files) => {

    const activeCount =
      type == "single"
        ? selectedFiles
          ? 1
          : 0
        : (selectedFiles || []).filter((f) => f.status != 3).length;

    if (type !== "single" && activeCount + files.length > MAX_FILE_LIMIT) {
      urtoast(`You can upload maximum ${MAX_FILE_LIMIT} files.`, 2);
      return;
    }
    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast("File size exceeds 10MB limit.", 2);
        return Promise.reject();
      }

      const isValidImage = validImageTypes.includes(file.type);
      const isValidDoc = validDocumentTypes.includes(file.type);

      // 🛡️ Explicitly enforce extension whitelist (blocks .jfif etc.)
      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Please upload a valid file type.", 2);
        return Promise.reject();
      }

      if (doctype == 1 && !isValidImage) {
        urtoast("Only images are allowed.", 2);
        return Promise.reject();
      }

      if (doctype !== 1 && !(isValidImage || isValidDoc)) {
        urtoast(`This file type is not supported`, 2);
        return Promise.reject();
      }

      const uniqueId = uuidv4();
      const storageRef = ref(getStorage(), `/Category/${uniqueId}_${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      return uploadTask
        .then(async () => {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          return url;
        })
        .catch((error) => {
          urtoast(`Error uploading ${file.name}: ${error.message}`, 2);
          throw error;
        });
    });

    Promise.all(uploadPromises)
      .then((uploadedUrls) => {
        if (type == "single") {
          const uploadedUrl = uploadedUrls[0];
          setSelectedFiles(uploadedUrl);
          formik.setFieldValue(name, uploadedUrl);
        } else {
          const updatedFiles = [
            ...(selectedFiles || []),
            ...uploadedUrls.map((url) => ({
              id: "",
              file: url,
              name: "",
              status: 1,
            })),
          ];
          setSelectedFiles(updatedFiles);
          formik.setFieldValue(name, updatedFiles);
        }
      })
      .catch((err) => console.error("Upload error:", err));
  };

  // Dropzone config
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleUpload,
    multiple: type != "single",
  });

  // 🗑️ FIXED: Delete handler with status 3 for backend
  const handleDeleteImage = (index) => {
    if (type == "single") {
      setSelectedFiles(null);
      formik.setFieldValue(name, null);
    } else {
      // Get the file from activeFiles to find it in selectedFiles
      const fileToDelete = activeFiles[index];

      // Mark the file with status 3 in selectedFiles array
      const updatedFiles = selectedFiles.map(item =>
        item.file === fileToDelete.file ? { ...item, status: 3 } : item
      );

      setSelectedFiles(updatedFiles);
      formik.setFieldValue(name, updatedFiles);
    }
  };

  // Active (non-deleted) files for UI
  const activeFiles =
    type == "single"
      ? selectedFiles
        ? [selectedFiles]
        : []
      : (selectedFiles || []).filter((item) => item.status !== 3);

  return (
    <div className="add-portfolio">
      <h6 className="skill-right file-attachment">
        {title ? title : "Upload Item Image"}{" "}
        {doctype !== 1 && <span>(Upload at least 1 file)</span>} <AsteriskLabel />
      </h6>

      <div className="col-md-12">
        <div className="row" style={{ rowGap: '30px' }}>
          {activeFiles.length == 0 ? (
            <div className="col-md-5">
              <div className="image-container">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
                  className="cover-img w-100"
                  alt="Upload Placeholder"
                />
              </div>
            </div>

          ) : (
            activeFiles.map((item, index) => (

              <div className="col-md-6" key={index}>
                <div className="image-container position-relative">
                  <DisplayFileProper
                    item={type == "single" ? { file: item } : item}
                  />
                  {/* <DownloadButton
                file={type == "single" ? { file: item } : item}
              /> */}
                  <button
                    type="button"
                    className="delete-button position-absolute top-0 end-0 m-1"
                    onClick={() => handleDeleteImage(index)}
                  >
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                      alt="Delete"
                    />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

      </div>

      {formik.touched[name] && formik.errors[name] && (
        <p style={{ color: "red" }}>{formik.errors[name]}</p>
      )}

      <div {...getRootProps({ className: "dropzone borderstylex mt-3" })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the file here...</p>
        ) : (
          <p>
            Drag and drop or <span> Browse Image</span>
          </p>
        )}
      </div>

      {doctype == 1 ? (
        ""
      ) : (
        <ul className="border-ul mt-2">
          <li>Images (JPG, PNG, JPEG up to 10MB)</li>
          <li>Documents (PDF up to 10MB)</li>
        </ul>
      )}
    </div>
  );
}